import React, { useState, useRef, useEffect } from 'react';

const ProgressiveImage = ({ src, placeholder, alt, className = '', style = {}, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // Reset on src change
    setLoaded(false);
  }, [src]);

  useEffect(() => {
    // Handle already-cached images
    if (imgRef.current && imgRef.current.complete && imgRef.current.naturalWidth > 0) {
      setLoaded(true);
    }
  }, []);

  return (
    <div className="relative overflow-hidden" style={{ ...style }} data-testid="progressive-image-wrapper">
      {/* Blurred placeholder — shows instantly (inline base64) */}
      {placeholder && (
        <img
          src={placeholder}
          alt=""
          aria-hidden="true"
          className={`${className} absolute inset-0 w-full h-full object-cover`}
          style={{
            filter: 'blur(20px)',
            transform: 'scale(1.1)',
            transition: 'opacity 0.4s ease-out',
            opacity: loaded ? 0 : 1,
          }}
          draggable="false"
        />
      )}

      {/* Full image — fades in when loaded */}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={className}
        style={{
          transition: 'opacity 0.5s ease-in',
          opacity: loaded ? 1 : 0,
        }}
        loading="lazy"
        draggable="false"
        onContextMenu={(e) => e.preventDefault()}
        onLoad={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default ProgressiveImage;
